import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_courttype = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_CASE_TYPE}/`);
};
export const dispute_resolution_getbyid_courttype = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_CASE_TYPE}/by-id/${id}`);
};
export const dispute_resolution_add_courttype = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_CASE_TYPE}/`, data);
};
export const dispute_resolution_update_courttype = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_CASE_TYPE}/${id}`, data);
};
export const dispute_resolution_delete_courttype = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_CASE_TYPE}/${id}`);
};
